<template>
<div>
    <v-card outlined v-if="loaded">
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="8">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn depressed color="accent" dark v-on="on">
                                {{actuaTextFilter}}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="actualFilter='all'">
                                <v-list-item-title>All profiles</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="actualFilter='directors'">
                                <v-list-item-title>Directors</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="actualFilter='captains'">
                                <v-list-item-title>Captains</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="actualFilter='students'">
                                <v-list-item-title>Students</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="actualFilter='denied'">
                                <v-list-item-title class="red--text font-weight-medium">Denied</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <v-text-field
                        v-model="search"
                        append-icon="fa-search"
                        label="Search"
                        single-line
                        hide-details
                        style="max-width: 300px"
                        class="mt-n3"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="headers"
            :items="filteredList"
            :items-per-page="25"
            no-data-text="No other users registered">
            <template v-slot:item.role="{ item }">
                <div v-if="item.role.master">Master</div>
                <div v-if="item.role.director">Director</div>
                <div v-if="item.role.captain">Captain</div>
                <div v-if="item.role.student">Student</div>
                <div v-if="item.role.denied"><span class="red white--text px-2 py-1 caption" style="border-radius:4px">Blocked</span></div>
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon small color="light-blue" class="mr-6" @click="$router.push('/profile/'+item.uid)">fa-link</v-icon>

                <v-menu offset-y v-if="item.uid != user.uid && (user.role.master || user.role.director)">
                    <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on" :disabled="item.role.master">
                            <v-icon small :class="(item.role.master) ? 'black--text' : 'accent--text'">fa-cog</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <!-- <v-list-item @click="setProfile(item.uid, 'director')">
                            <v-list-item-title>Director</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="setProfile(item.uid, 'captain')">
                            <v-list-item-title>Captain</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="setProfile(item.uid, 'student')">
                            <v-list-item-title>Student</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item @click="blockProfile(item, true)" v-if="item.role.denied == undefined">
                            <v-list-item-title class="red--text font-weight-medium">Deny access</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="blockProfile(item, false)" v-if="item.role.denied">
                            <v-list-item-title class="success--text font-weight-medium">Allow access</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </v-card>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Users from '@/firebase/users'
import Metrics from '@/services/metrics'
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        items: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'Email', value: 'email' },
          { text: 'Profile', value: 'role' },
          { text: 'Stats', value: 'metrics.calif', align: 'center' },
          { text: 'Action', value: 'action' },
        ],
        search: '',
        actualFilter: 'all',
        actuaTextFilter: ''
    }),
    props: ['tab'],
    mounted() {
        this.init();
    },
    watch: {
        tab() {
            if (this.tab == 0) {
                this.init();
            }
        }
    },
    computed: {
        filteredList() {
            if (this.loaded) {
                let final = [];
                let tempo = [];

                if (this.actualFilter != 'all') {
                    this.items.forEach(dt => {
                        if (this.actualFilter == 'directors' && dt.role.director) {
                            tempo.push(dt);
                        }
                        if (this.actualFilter == 'captains' && dt.role.captain) {
                            tempo.push(dt);
                        }
                        if (this.actualFilter == 'students' && dt.role.student) {
                            tempo.push(dt);
                        }
                        if (this.actualFilter == 'denied' && dt.role.denied) {
                            tempo.push(dt);
                        }
                    });
                } else {
                    tempo = this.items;
                }

                final = tempo.filter(item => {
                        return item.name.toLowerCase().includes(this.search.toLowerCase());
                    });
                
                if (this.actualFilter == 'all') {
                    this.actuaTextFilter = 'All Profiles' + ' (' + final.length + ')';  
                } else {
                    this.actuaTextFilter = this.actualFilter + ' (' + final.length + ')';
                }
                
                return final;
            } else {
                return [];
            }
        }
    },
    methods: {
        init() {
            this.loaded = false;
            this.items = [];

            let factor = '';
            
            if (this.user.role.master)  factor = 'master';
            if (this.user.role.director)  factor = {role:'director', center:this.user.center};
            if (this.user.role.captain)  factor = {role:'captain', center:this.user.center};

            Users.getAllNotPending('master')
                    .then(response => {
                        if (response.status == true) {
                            this.items = Helpers.formatItems(response.query, 'uid');
                            this.items.forEach(dt => {
                                if (dt.role.student) {
                                    dt.metrics = Metrics.get(dt);
                                } else {
                                    dt.metrics = {calif: '-', map: null}
                                }
                            });
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        // setProfile(uid, status) {
        //     Users.setProfile(uid, status)
        //             .then(response => {
        //                 if (response == true) {
        //                     this.init();
        //                 } else {
        //                     this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
        //                 }
        //             });
        // },
        blockProfile(item, est) {
            let role = item.role;

            if (est) {
                role.denied = true;
            } else {
                delete role.denied;
            }
            
            Users.blockProfile(item.uid, item.role)
                    .then(response => {
                        if (response == true) {
                            this.init();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>